import React from 'react';
import { MeatballMenu } from 'ui';
import { ValidationMessage } from 'ui/common/validation/types';
import styles from './safety-limit-tile.scss';

export interface SafetyLimitTileHeaderProps {
  title: string;
  errors: ValidationMessage[];
  readOnly: boolean;
  onRemove: () => void;
  removeLabel: string;
}

export const SafetyLimitTileHeader: React.FC<SafetyLimitTileHeaderProps> = ({ title, errors, readOnly, onRemove, removeLabel }) => (
  <div className={styles.tileHeader}>
    <div>
      <h3>{title}</h3>
      {errors.length > 0 && (
        <div className={styles.validationMessageWrapper}>
          <ul>
            {errors.map((item, index) => (
              <li key={index} className="list-group-item-danger">{item.message}</li>
            ))}
          </ul>
        </div>
      )}
      {!readOnly && (
        <MeatballMenu className={styles.meatball} closeAfterClick={true}>
          <li>
            <button type="button" className="dropdown-item" onClick={onRemove}>
              {removeLabel}
            </button>
          </li>
        </MeatballMenu>
      )}
    </div>
  </div>
);
